import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import AdjustPrompt from 'components/admin/AdjustPrompt';
import AuthButton from 'components/base/AuthButton';
import { SaveAndBackButtons } from 'components/base/BottomStepComponent';
import ContentSections from 'components/base/ContentSections';
import CustomBreadcrumb from 'components/base/CustomBreadcrumb';
import CustomButtonWithTips from 'components/base/CustomButtonWithTips';
import CustomListComponent from 'components/base/CustomListComponent';
import ListButtonsGroup from 'components/base/ListButtonsGroup';
import Loading from 'components/base/Loading';
import ContentSection from 'components/campaign/campaignCreation/ContentSection';
import ProfileSection from 'components/campaign/campaignCreation/ProfileSection';
import RecurringMessagePerformance from 'components/campaign/campaignCreation/RecurringMessagePerformance';
import {
  ADJUST_TYPES,
  APIStatus,
  AppCampaignDetailUrl,
  CampaignDetailUrl,
  CampaignType,
  LanguageConfig,
  SESSION_KEYS,
} from 'config/CustomEnums';
import { PermissionCodes } from 'config/PermissionCodes';
import { ToastType } from 'models/NavBarModel';

import { createAction, removeFromSessionStorage } from 'utils';
import MembershipInfoCard from 'components/customer/MembershipInfoCard';
import { ImportResource } from 'models/DownloadImportModel';
import { noWebapp, onlyHaveWebapp } from 'config/CustomEnums';

function CampaignDetail({ createStatus, campaign }) {
  const params = useParams();
  const { id } = params;
  const dispatch = useDispatch();
  const history = useHistory();

  const [adjustPrompt, setAdjustPrompt] = useState({
    show: false,
    adjustType: null,
    prefillData: {},
  });

  useEffect(() => {
    console.log('@32');
    removeFromSessionStorage(SESSION_KEYS.CREATE_CAMPAIGN_PERVIEW_SESSION_KEY);
    dispatch(
      createAction('createCampaign/getOneCampaign')({ id, isDetail: true }),
    );
    dispatch(createAction('language/getList')({ isSelectorLoad: true }));
    return () => dispatch({ type: 'createCampaign/clearData' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const exportAction = () => {
    dispatch({
      type: 'downloadAndImport/createDownloadTask',
      payload: {
        from: ImportResource.ticketQusetion,
        related: {
          ticketCampaign: params.id,
        },
      },
    });
  }

  const copiedDeeplinkAction = () => {
    dispatch({
      type: 'navBars/updateState',
      payload: {
        saveDiscardToastShowing: {
          value: true,
          type: ToastType.copySuccess,
        },
      },
    });
  };

  const copyDeeplinkToClipboard = (url) => {
    navigator.clipboard.writeText(url);
  };

  if (createStatus === APIStatus.calling) {
    return <Loading customClass={'common-full-height '} />;
  }

  const sections = [
    <ProfileSection data={campaign} />,
    <MembershipInfoCard
      title={'GENERAL'}
      data={campaign}
      fields={[
        [
          {
            title: 'Status',
            field: 'displayStatus',
          }
        ],
        [
          {
            title: 'Creation time',
            field: 'displayCreationDate',
          }
        ],
        [
          {
            title: 'Last modified time',
            field: 'displayLastModifiedDate',
          }
        ],
        [
          {
            title: 'Last modified by',
            field: 'displayLastModifiedBy',
          }
        ],
      ]}
    />
  ];

  if (campaign?.isBirthdayRecurringCampaign && !!campaign?.recurringMessage?.channels?.length) {
    sections.splice(1, 0, <RecurringMessagePerformance data={campaign}/>)
  }

  const tabs = [
    {
      name: 'Detail',
      content: (
        <div className="scroll-container-common">
          <ContentSection data={campaign} />
          <ContentSections sections={sections} hidePreview={true} />
          <SaveAndBackButtons backAction={() => history.push('/campaigns/')} />
        </div>
      ),
    },
  ];
  const buttons = [
    <ListButtonsGroup
      hideExtraButtonWidth={1000}
      hideAllButtonWidth={400}
      extraButtons={[
        campaign?.campaignType === CampaignType.ticketCampaign &&
        <CustomButtonWithTips
          className='btn-back-button-common custom-button-with-tips btn-download'
          title={'Export results'}
          action={exportAction}
        />,
        <CustomButtonWithTips
          tipsContent={(
            'When customer click on the link, will open ' +
            'the page in website and show a banner for customer ' +
            'to open the same content in native app, ' +
            'redirect to app store if the native app has not been installed.'
          )}
          className='btn-back-button-common'
          title={'Copy URL for web'}
          action={() => {
            const url = `${CampaignDetailUrl}${id}`;
            copyDeeplinkToClipboard(url);
            copiedDeeplinkAction();
          }}
        />,
        <CustomButtonWithTips
          tipsContent={(
            'When customer click on the link, ' +
            'will redirect to native app if the app has been installed; ' +
            'if not installed, will show a page to app store.'
          )}
          className='btn-back-button-common'
          title={'Copy deep link for app'}
          action={() => {
            const url = `${AppCampaignDetailUrl}${id}`;
            copyDeeplinkToClipboard(url);
            copiedDeeplinkAction();
          }}
          hidden={onlyHaveWebapp}
        />,
        campaign?.campaignType === CampaignType.ticketCampaign && (
          <AuthButton
            customClass="btn-back-button-common btn-download"
            title="Adjust ticket"
            action={() => {
              setAdjustPrompt({
                show: true,
                adjustType: ADJUST_TYPES.ticket,
              });
            }}
            requires={PermissionCodes.adjustAllRewards}
          />
        ),
      ]}
      primaryButton={
        <AuthButton
          title="Edit"
          action={() => {
            dispatch({ type: 'admin/clearData' });
            history.push({
              pathname: 'edit/',
            });
          }}
          requires={PermissionCodes.changeCampaign}
        />
      }
      primaryPopContent={{
        requires: PermissionCodes.changeCampaign,
        action: () => {
          dispatch({ type: 'admin/clearData' });
          history.push({
            pathname: 'edit/',
          });
        },
        content: 'Edit',
      }}
    />,
  ];

  return (
    <>
      <CustomListComponent
        caution={{
          detail: '',
          title: campaign.translations?.[LanguageConfig.english]?.generalName,
        }}
        hideTab
        breadcrumb={
          <CustomBreadcrumb
            name={campaign.translations?.[LanguageConfig.english]?.generalName}
          />
        }
        buttons={buttons}
        tabs={tabs}
      />
      <AdjustPrompt
        show={adjustPrompt.show}
        adjustType={adjustPrompt.adjustType}
        prefillData={{
          ...(adjustPrompt.prefillData || {}),
          targetCampaign: campaign,
        }}
        setShow={(value) => setAdjustPrompt({ show: value })}
      />
    </>
  );
}

const mapPropsToState = (state) => ({
  createStatus: state.createCampaign.createStatus,
  campaign: state.createCampaign.campaign || {},
  webhookAuthenticatedKey: state.createCampaign.webhookAuthenticatedKey,
  isCopied: state.createCampaign.isCopied,
});

export default connect(mapPropsToState)(CampaignDetail);
